/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  
  
  $(document).ready(function () {
  // 1. Initially hide all color/pattern blocks
  $('.menu__color_links').hide();
  $('.menu__pattern_links').hide(); // If using this class for pattern blocks

  // 2. Helpers to build arrow/back buttons
  function getArrowHTML(text) {
    return `
      <span class="sliderow__title">
        ${text}
        <span class="sliderule__chevron--right">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-right" viewBox="0 0 24 24">
            <path d="M6 12h12.5m0 0-6-6m6 6-6 6" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
          <span class="visually-hidden">Show menu</span>
        </span>
      </span>
    `;
  }

  function getBackHTML(text) {

    return `
      <span class="sliderow__title">
        <span class="sliderule__chevron--left">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-left" viewBox="0 0 24 24">
            <path d="M18.5 12H6m0 0 6-6m-6 6 6 6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </span>
        <span class="sliderule__inner">${text}</span>
      </span>
    `;
  }

  function activateSubmenu($btn, $otherBtn, text, backText, showSelector) {
    // Hide all content blocks
    $('.menu__block').hide();

    $('.sliderow.sliderow--back').hide();

    // Show relevant submenu
    $(showSelector).show();

    // Change to back button
    $btn.addClass('is-back').data('original-text', text);
    $btn.html(getBackHTML(backText));

    // Hide sibling option
    $otherBtn.hide();
    $('.shopByLinks').hide();


    // Back click resets everything
    $btn.off('click').on('click', function () {
      resetAll();
    });
  }

  function resetButton($btn) {
    const originalText = $btn.data('original-text');
    if (originalText) {
      $btn.removeClass('is-back');
      $btn.html(getArrowHTML(originalText));
    }
  }

  function resetAll() {
    // Reset buttons
    $('.sliderow[id^="shopBy"]').each(function () {
      const $btn = $(this);
      resetButton($btn);
      $('.shopByLinks').show();
      $btn.show();
    });

    // Hide submenu content
    $('.menu__block').hide();

    $('.sliderow.sliderow--back').show();


    // Re-bind click handlers
    setupClickHandlers();
  }

  function setupClickHandlers() {
    $('#shopByColourFabric').off('click').on('click', function () {
      activateSubmenu(
        $(this),
        $('#shopByPatternFabric'),
        'Shop by Colour',
        'Colours',
        '.menu__color_links[data-position="1"]'
      );
    });

    $('#shopByPatternFabric').off('click').on('click', function () {
      activateSubmenu(
        $(this),
        $('#shopByColourFabric'),
        'Shop by Category',
        'Categories',
        '.menu__block:not(.menu__color_links)'
      );
    });

    $('#shopByColourWallpaper').off('click').on('click', function () {
      activateSubmenu(
        $(this),
        $('#shopByPatternWallpaper'),
        'Shop by Colour',
        'Colours',
        '.menu__color_links[data-position="2"]'
      );
    });

    $('#shopByPatternWallpaper').off('click').on('click', function () {
      activateSubmenu(
        $(this),
        $('#shopByColourWallpaper'),
        'New Designs',
        'Patterns',
        '.menu__block:not(.menu__color_links)'
      );
    });
  }

  // Initial run
  setupClickHandlers();
});


  document.addEventListener("DOMContentLoaded", function() {
  
    document.addEventListener('click', function(event) {
      var activeTitles = document.querySelectorAll('.snize-filters-dropdown-title.active');
  
      activeTitles.forEach(function(title) {
          var content = title.nextElementSibling;
  
          console.log('Title:', title);
          console.log('Content:', content);
  
          if (content && window.getComputedStyle(content).display === 'none') {
              title.classList.remove('active');
          }
      });
  });
  


    var toggles = document.querySelectorAll('.toggle_check');

    toggles.forEach(function(toggle) {
        var targetId = toggle.getAttribute('data-toggle');
        var targetDiv = document.getElementById(targetId);
        var targetInput = targetDiv.querySelector('input');

        toggle.addEventListener('change', function() {
          console.log('toggle change');
            if (this.checked) {
                targetDiv.style.display = 'block';
                targetInput.required = true;
            } else {
                targetDiv.style.display = 'none';
                targetInput.required = false;
            }
        });
    });
});

$(document).ready(function() {
  $('a[href="#account"].btn').on('click', function(event) {
      event.preventDefault(); 

      var target = $('#account_section');
      var offset = 120;

      $('html, body').stop(true, true).animate({
        scrollTop: target.offset().top - offset
      }, 300); 
  });

});

function updateAddToCartState() {
  const $button = $('button[data-add-to-cart]');
  const variantId = $button.data('variant-id');

  const remaining = parseInt($('span.variant__countdown--low span[data-remaining-count]').text(), 10) || 999999;
  const inputQty = parseInt($('.quantity__input').val(), 10) || 0;

  $.getJSON('/cart.js', function(cart) {
    let cartQty = 0;

    cart.items.forEach(item => {
      if (item.variant_id === variantId) {
        cartQty = item.quantity;
      }
    });

    const availableQty = remaining - cartQty;

    if (inputQty > availableQty) {
      $button.prop('disabled', true).addClass('disabled');
    } else {
      $button.prop('disabled', false).removeClass('disabled');
    }

    console.log(availableQty)
    console.log(inputQty)
    console.log((inputQty > availableQty))


  });
}

$(document).ready(function() {
  updateAddToCartState();
  var fabricForceVariantId = $('.product__block--buttons.fabric_force button[name="add"][data-variant-id]').attr('data-variant-id');
  $('.product__block--buttons.fabric_force input[name="product-id"]').val(fabricForceVariantId)
});

$('.product__block--buttons.fabric_force form').on('submit', function(e) {
  e.preventDefault();

  var fabricForceVariantId = $('.product__block--buttons.fabric_force button[name="add"][data-variant-id]').attr('data-variant-id');

  if (!fabricForceVariantId) {
    console.error('Variant ID not found!');
    return;
  }

  var formData = {
    id: fabricForceVariantId,
    quantity: $('input[name="quantity"]').val(),
    properties: {
      Code: $('input[name="properties[Code]"]').val(),
      _Type: $('input[name="properties[_Type]"]').val()
    }
  };

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: formData,
    dataType: 'json',
    success: function(response) {
      console.log('Product added:', response);
      window.location = '/cart';
    },
    error: function(xhr, status, error) {
      console.error('Error adding product to cart:', xhr.responseText);
    }
  });
});


$(document).on('click', '.select-popout__option', function() {
  updateAddToCartState();
});

$(document).on('click', '.cart__quantity-minus', function() {
  setTimeout(updateAddToCartState, 400);
});

$(document).on('click', '.cart__quantity-plus', function() {
  setTimeout(updateAddToCartState, 400);
});

$(document).on('input change', '.quantity__input', function() {
  updateAddToCartState();
});

$(document).on('input change', '.cart__quantity-field', function() {
  setTimeout(updateAddToCartState, 400);
});

const drawer = document.getElementById('cart-drawer');

if (drawer) {
  const classObserver = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      if (mutation.attributeName === 'class') {
        updateAddToCartState();
      }
    });
  });

  classObserver.observe(drawer, {
    attributes: true,
    attributeFilter: ['class']
  });
}

  function updateCartCount(updatedCart) {
    $('span[data-cart-count]').each(function() {
        $(this).attr('data-cart-count', updatedCart.item_count).text(updatedCart.item_count);
    });

}

$(document).ready(function() {

  function fetchCartData() {
    return $.ajax({
      url: '/cart.json',
      method: 'GET',
      dataType: 'json'
    });
  }
const MAX_SAMPLES = $('footer').attr('data-sample') || 6;

function updateSampleButtonUI($button, cartData) {
  const sampleVariantId = Number($button.data('sample-variant-id'));
  const productHandle = $button.data('product-handle');
  const cuttingsThreshold = Number($button.data('sample-threshold')) || 1;

  let cuttingsCount = 0;       // "Cuttings" variant in cart
  let otherItemsCount = 0;     // This sample variant in cart
  let totalSamples = 0;        // All samples in cart

  if (cartData && cartData.items) {
    cartData.items.forEach(item => {
      if (item.properties && item.properties._Type?.includes('Sample')) {
        totalSamples += Number(item.quantity) || 0;
      }

      if (item.variant_id === sampleVariantId) {
        otherItemsCount += Number(item.quantity) || 0;
      } else if (item.variant_title?.toLowerCase() === 'cuttings') {
        cuttingsCount += Number(item.quantity) || 0;
      }
    });
  }

  if (otherItemsCount >= 1) {
    $button.addClass('disabled-btn').prop('disabled', true).text('Sample added');
    //$button.siblings('.sample-message').html('You already have this sample in your cart').show();
  } else if (totalSamples >= MAX_SAMPLES) {
    $button.addClass('disabled-btn').prop('disabled', true).text('Sample limit reached');
    if (!($('body').hasClass('sample-limit'))) {
      $('body:not(.sample-limit) #popupSampleLimit').show();
    }
    $('body').addClass('sample-limit');
    //$button.siblings('.sample-message').html('Total sample limit reached').show();
  } else {
    $button.removeClass('disabled-btn').prop('disabled', false).text('Add Sample');
   // $button.siblings('.sample-message').html('').hide();
  }
}

function handleSampleButtonClick() {
  var $button = $(this);

  if ($button.hasClass('disabled-btn')) return;

  var variantId = $button.data('sample-variant-id');
  var typeProp = $button.data('sample-type');
  var codeProp = $button.data('sample-code');
  var productHandle = $button.data('product-handle');

  if (!variantId) {
    $button.siblings('.sample-message').text('Variant not found!').show();
    return;
  }

  $button.find('.btn__loader').show();
  $button.addClass('disabled-btn');

  $.getJSON('/cart.js', function(cart) {
    let totalSamples = 0;
    let thisSampleInCart = false;

    cart.items.forEach(item => {
      if (item.properties && item.properties._Type?.includes('Sample')) {
        totalSamples += item.quantity;
        if (item.variant_id === variantId || item.handle === productHandle) {
          thisSampleInCart = true;
        }
      }
    });


    if (thisSampleInCart || totalSamples >= MAX_SAMPLES) {
      $button.find('.btn__loader').hide();
      $button.prop('disabled', true).addClass('disabled-btn');
      $button.text(thisSampleInCart ? 'Sample Added' : 'Sample limit reached');
      if (!($('body').hasClass('sample-limit'))) {
        $('body:not(.sample-limit) #popupSampleLimit').show();
      }
      $('body').addClass('sample-limit');

      return;
    }

    $.ajax({
      url: '/cart/add.js',
      method: 'POST',
      dataType: 'json',
      data: {
        quantity: 1,
        id: variantId,
        properties: {
          'Code': codeProp || '',
          '_Type': typeProp
        }
      }
    }).done(function() {
      fetchCartData().done(function(updatedCart) {
        updateSampleButtonUI($button, updatedCart);
        $('#cart-drawer').load(window.location.href + ' #cart-drawer > *');
        updateCartCount(updatedCart);

      });
    }).fail(function() {
      $button.siblings('.sample-message').text('Error adding sample').show();
    }).always(function() {
      $button.find('.btn__loader').hide();
    });
  });
}


  $(document).on('click', '.add-sample-btn', handleSampleButtonClick);

  $(document).on('theme:cart:change theme:cart:add', function() {
    fetchCartData().done(function(cartData) {
      $('.add-sample-btn').each(function() {
        updateSampleButtonUI($(this), cartData);
      });
    });
  });

  fetchCartData().done(function(cartData) {
    $('.add-sample-btn').each(function() {
      updateSampleButtonUI($(this), cartData);
    });
  });

});



const maxSamples = $('footer').attr('data-sample') || 6;;

function injectSampleButtons() {
  let cartChecked = false;
  $('.snize-product').each(function() {
    const $product = $(this);
    const $link = $product.find('.snize-view-link');
    if (!$link.length) return;

    const productHandle = $link.attr('href').split('/products/')[1];
    //const jsonUrl = `/products/${productHandle}.json`;
    const jsonUrl = `/products/${productHandle}?view=samples`;



    if ($product.find('.add-sample-btn').length > 0) return;

    let codeProp = '';
    $product.find('.snize-attribute').each(function() {
      const titleText = $(this).find('.snize-attribute-title').text().trim();
      if (titleText === 'product.product_codes_merged:') {
        codeProp = $(this).text().replace(titleText, '').trim();
        if (codeProp.includes('-')) {
          codeProp = codeProp.split('-')[0].trim();
        }
      }
    });

    const $button = $(`
      <button class="add-sample-btn disabled-btn" data-sample-threshold="1">
        Add Sample <span class="btn__loader" style="display:none;">⏳</span>
      </button>
    `);


    $.getJSON(jsonUrl, function(data) {
      const product = data.product;
      if (!product || !product.variants || product.variants.length === 0) return;

      let sampleVariantId = null;

      product.variants.forEach(v => {

        if (v.title === 'Cuttings' && parseFloat(v.price) === 0) {
          sampleVariantId = v.id;
        }
      });

      if (sampleVariantId != null && $product.find('.add-sample-btn').length === 0) {
          $product.append($button);
      }

      $button.data('sample-variant-id', sampleVariantId);
      $button.data('sample-code', codeProp);
      $button.data('sample-type', product.product_type + ' Sample');

      $.getJSON('/cart.js', function(cart) {
        let totalSamples = 0;
        let productSampleInCart = false;

        cart.items.forEach(item => {
          if (item.properties && item.properties._Type && item.properties._Type.includes('Sample')) {
            totalSamples += item.quantity;
            if (item.handle === productHandle) productSampleInCart = true;
          }
        });

        if (totalSamples >= maxSamples) {
          $button.prop('disabled', true).text('Sample limit reached').addClass('disabled-btn');
          if (!($('body').hasClass('sample-limit'))) {
            $('body:not(.sample-limit) #popupSampleLimit').show();
          }
          $('body').addClass('sample-limit');



        } else if (productSampleInCart) {
          $button.prop('disabled', true).text('Sample Added').addClass('disabled-btn');
        } else {
          $button.removeClass('disabled-btn');
        }


      });
      cartChecked = true;
    });

    $.ajax({
      method: 'get',
      url: `/products/${productHandle}?view=samples`,
      success: function (res) {

        var json = JSON.parse(res);
        if ($product.find('.sample-colourway').length > 0) return;
        if ($product.find('.sample-design').length > 0) return;
        if ($('body').hasClass('template_page_order-samples')) {
          $product.find('.snize-overhidden')
          .append(`<div class="sample-colourway">${json.colourway}</div>`)
          .append(`<div class="sample-design">${json.design}</div>`);
        };


      }
    });

    $button.on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const variantId = $(this).data('sample-variant-id');
      const codeProp = $(this).data('sample-code');
      const typeProp = $(this).data('sample-type');

      if (!cartChecked) {
        console.log('Please wait, loading cart...');
        return;
      }

      if (!variantId) {
        $(this).siblings('.sample-message').text('Variant not found!').show();
        return;
      }

      $(this).find('.btn__loader').show();

      $.getJSON('/cart.js', function(cart) {
        let totalSamples = 0;
        let productSampleInCart = false;

        cart.items.forEach(item => {
          if (item.properties && item.properties._Type && item.properties._Type.includes('Sample')) {
            totalSamples += item.quantity;
            if (item.handle === productHandle) productSampleInCart = true;
          }
        });

        if (totalSamples >= maxSamples) {
          $button.find('.btn__loader').hide();
          $button.prop('disabled', true).text('Sample limit reached').addClass('disabled-btn');
          if (!($('body').hasClass('sample-limit'))) {
            $('body:not(.sample-limit) #popupSampleLimit').show();
          }
          $('body').addClass('sample-limit');


          return;
        }

        if (productSampleInCart) {
          $button.find('.btn__loader').hide();
          $button.prop('disabled', true).text('Sample Added').addClass('disabled-btn');
          return;
        }
$.ajax({
  url: '/cart/add.js',
  method: 'POST',
  dataType: 'json',
  data: {
    quantity: 1,
    id: variantId,
    properties: {
      'Code': codeProp,
      '_Type': typeProp
    }
  }
}).done(() => {
  $.getJSON('/cart.js', function(updatedCart) {
    $button.find('.btn__loader').hide();
    $button.prop('disabled', true).text('Sample Added').addClass('disabled-btn');

    $('#cart-drawer').load(window.location.href + ' #cart-drawer > *');
    updateCartCount(updatedCart);

  });
}).fail(() => {
  $button.find('.btn__loader').hide();
  $button.siblings('.sample-message').text('Error adding sample').show();
});



      });
    });
  });

}

injectSampleButtons();


$(document).on('click', '.add-sample-btn', function(e) {
  e.preventDefault();
  e.stopPropagation();
});


    $(document).on('Searchanise.ResultsUpdated', function(event, container) {
      setTimeout(function(){
          injectSampleButtons();
          console.log('searchanise updated')
        },100)
    });

$(document).on('click', 'button.drawer__close', function(e) {
  $('.drawer__underlay').click()
});
    
$(document).on('click', '#popupSampleLimit button[data-popup-close]', function(e) {
      $('#popupSampleLimit').hide();
      //$('body').removeClass('sample-limit')
});

$(document).on('click', 'body.sample-limit', function(e) {
    if (!$(e.target).closest('#popupSampleLimit').length) {
        $('#popupSampleLimit').hide();
        //$('body').removeClass('sample-limit');
    }
});


    $('').show();




function processIwishItems00() {
  const items = document.querySelectorAll("li.iwishItem[data-handle]:not([data-meta-loaded])");

  items.forEach(async (item) => {
    const handle = item.dataset.handle;
    if (!handle) return;

    item.setAttribute("data-meta-loaded", "true");

    const transferBtn = item.querySelector('.iwishCategoryTransferBtn');
    if (transferBtn) transferBtn.textContent = "Move to Another List";


    try {
      const res = await fetch(`/products/${handle}?view=samples`);
      const product = await res.json();
      const code = product?.codes_merged;
      const typeElement = item.querySelector('.iwishMeta-variant-title');
      const typeProp = typeElement ? typeElement.textContent.trim() : '';

      if (code) {
        const span = document.createElement("span");
        span.className = "iwish-product-code";
        span.textContent = code;
        const container = item.querySelector('.iwishMeta');
        if (container) container.appendChild(span);




        const button = document.createElement("button");
        button.type = "button";
        button.className = "btn btn--primary iwish-add-to-cart";
        button.innerHTML = `<span class="btn__text">Add to Basket</span><span class="btn__loader" style="display:none;"></span><span class="sample-message" style="display:none;color:red;"></span>`;
          if (product.variants[0].price === 0) {
            injectIwishSampleButton(item, product, code, typeProp);
          } else {
            container.appendChild(button);
          }


          button.addEventListener("click", () => {
          const $button = $(button);
          $button.find('.btn__loader').show();

          let variantId = product.variants[0].id;
          if (product.variants[0].price === 0 && product.variants.length > 1) {
            variantId = product.variants[1].id;
          }

          const firstPrice = product.variants[0]?.price || 0;
          const secondPrice = product.variants[1]?.price || 0;
          if (firstPrice === 0 && secondPrice === 0) return;

          $.ajax({
            url: '/cart/add.js',
            method: 'POST',
            dataType: 'json',
            data: {
              quantity: 1,
              id: variantId,
              properties: {
                'Code': code,
                '_Type': typeProp
              }
            }
          }).done(() => {
            $.getJSON('/cart.js', function(updatedCart) {
              $button.find('.btn__loader').hide();
              $button.prop('disabled', true).text('Added to Basket').addClass('disabled-btn');

              $('#cart-drawer').load(window.location.href + ' #cart-drawer > *');
              if (typeof updateCartCount === "function") updateCartCount(updatedCart);
            });
          }).fail(() => {
            $button.find('.btn__loader').hide();
            $button.find('.sample-message').text('Error adding item').show();
          });
        });



      }

    } catch (e) {}
  });


}

const observer = new MutationObserver(() => {
  if (document.querySelector(".iwishWrapper")) {
    //processIwishItems();
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

function injectIwishSampleButton(item, product, codeProp, typeProp) {
  const container = item.querySelector('.iwishMeta');
  if (!container) return;

  if (container.querySelector('.add-sample-btn')) return;

  const button = document.createElement("button");
  button.className = "add-sample-btn disabled-btn";
  button.innerHTML = `Add Sample <span class="btn__loader" style="display:none;">⏳</span>`;
  container.appendChild(button);

  let sampleVariantId = null;

  product.variants.forEach(v => {
    if (v.title === 'Cuttings' && parseFloat(v.price) === 0) {
      sampleVariantId = v.id;
    }
  });

  if (!sampleVariantId) {
    button.remove();
    return;
  }

  $(button).data('sample-variant-id', sampleVariantId);
  $(button).data('sample-code', codeProp);
  $(button).data('sample-type', typeProp + ' Sample');
  $(button).data('product-handle', product.handle);

  $.getJSON('/cart.js', function(cart) {
    let totalSamples = 0;
    let sampleInCart = false;

    cart.items.forEach(item => {
      if (item.properties && item.properties._Type && item.properties._Type.includes('Sample')) {
        totalSamples += item.quantity;
        if (item.handle === product.handle) {
          sampleInCart = true;
        }
      }
    });

    if (totalSamples >= maxSamples) {
      button.disabled = true;
      button.classList.add('disabled-btn');
      button.textContent = 'Sample limit reached';

      if (!document.body.classList.contains('sample-limit')) {
        $('#popupSampleLimit').show();
      }
      document.body.classList.add('sample-limit');

    } else if (sampleInCart) {
      button.disabled = true;
      button.classList.add('disabled-btn');
      button.textContent = 'Sample Added';

    } else {
      button.classList.remove('disabled-btn');
    }
  });
}

$(document).on('click', 'a.iWishAddColl.iwishcheck', function (e) {
  e.stopPropagation(); 
  e.preventDefault();
  try {
    if (typeof iWish !== 'undefined') {
      setTimeout(function () {
        iWish.checkIwishColl();
      }, 1500);
    }
  } catch (error) {
    console.log(error);
  }
});


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
